import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { formConstants } from '../../utils/constants/form-constants';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { deepCopyObject, isEmpty } from '../../utils/obj-utils';

class FormAddressDisplayField extends Component {
    constructor(props) {
        super(props);
        this.state = { mainValue: false, shippingAddressValue: false, billingAddressValue: false };
        this.handleEditAddress = this.handleEditAddress.bind(this);
        this.handleRemoveAddress = this.handleRemoveAddress.bind(this);
        this.handleUpdateAddress = this.handleUpdateAddress.bind(this);
        this.updateAddressValues = this.updateAddressValues.bind(this);
        this.displayCitySection = this.displayCitySection.bind(this);
        this.displayCountrySection = this.displayCountrySection.bind(this);
    }

    componentDidMount() {
        const { address } = this.props;
        this.updateAddressValues(address);
    }

    componentWillReceiveProps(nextProps) {
        const { address } = nextProps;
        this.updateAddressValues(address);
    }

    handleEditAddress(event) {
        event.preventDefault();
        const { address, onEditAddressClick } = this.props;
        onEditAddressClick(address);
    }

    handleRemoveAddress(event) {
        event.preventDefault();
        const { address, onRemoveAddressClick } = this.props;
        onRemoveAddressClick(address);
    }

    handleUpdateAddress(event, addressType) {
        event.preventDefault();
        const { address, onUpdateAddressClick } = this.props;

        const updatedAddress = deepCopyObject(address);
        updatedAddress[addressType] = !updatedAddress[addressType];

        this.updateAddressValues(updatedAddress);
        onUpdateAddressClick({ addressFlaggedForUpdate: address, updatedAddress });
    }

    updateAddressValues(address) {
        const mainValue = address.main;
        const shippingAddressValue = address.shippingAddress;
        const billingAddressValue = address.billingAddress;

        this.setState({ mainValue, shippingAddressValue, billingAddressValue });
    }

    displayCitySection() {
        const { address } = this.props;

        if (isEmpty(address[formConstants.city])) {
            return `${address[formConstants.postcode]}`;
        }

        return `${address[formConstants.postcode]}, ${address[formConstants.city]}`;
    }

    displayCountrySection() {
        const { address } = this.props;

        if (isEmpty(address[formConstants.county])) {
            if (isEmpty(address[formConstants.stateName])) {
                return `${address[formConstants.countryName]}`;
            }

            return `${address[formConstants.countryName]}, ${address[formConstants.stateName]}`;
        }

        return `${address[formConstants.countryName]}, ${address[formConstants.county]}`;
    }

    render() {
        const {
            formData,
            address,
            isLast
        } = this.props;

        const { mainValue, shippingAddressValue, billingAddressValue } = this.state;
        const { mainAddress, shippingAddress, billingAddress } = formData;

        return (<Fragment>
            <div className={`address ${address.main ? 'main' : ''} ${isLast ? 'last' : ''}`}>
                <h3 className='subtitle'> {mainValue ? '● Main address' : ''} {shippingAddressValue ? '● Shipping address' : ''} {billingAddressValue ? '● Billing address' : ''}</h3>
                <div className='top'>
                    <div className='left'>
                        <div className='street'>{address[formConstants.addressLine1]}</div>
                        <div className='street'>{address[formConstants.addressLine2]}</div>
                        <div className='street'>{address[formConstants.addressLine3]}</div>
                        <div className='city'>{`${this.displayCitySection()}`}</div>
                        <div className='country'>{`${this.displayCountrySection()}`}</div>
                    </div>
                    <ul className='right'>
                        <li>
                            <div
                                className={'form-field auto-mt-xs'}
                                data-dc-component='form-field'
                                data-form-control
                            >
                                <label className='form-switch'>
                                    <input
                                        type='checkbox'
                                        className='form-checkbox__checkbox visually-hidden'
                                        name='mainAddress'
                                        id='mainAddress'
                                        onChange={(e) => this.handleUpdateAddress(e, formConstants.main)}
                                        checked={mainValue} /><i></i>{mainAddress.label}</label>
                            </div>
                        </li>
                        <li>
                            <div
                                className={'form-field auto-mt-xs'}
                                data-dc-component='form-field'
                                data-form-control
                            >
                                <label className='form-switch'>
                                    <input
                                        type='checkbox'
                                        className='form-checkbox__checkbox visually-hidden'
                                        name='shippingAddress'
                                        id='shippingAddress'
                                        onChange={(e) => this.handleUpdateAddress(e, formConstants.shippingAddress)}
                                        checked={shippingAddressValue} /><i></i>{shippingAddress.label}</label>
                            </div>
                        </li>
                        <li>
                            <div
                                className={'form-field auto-mt-xs'}
                                data-dc-component='form-field'
                                data-form-control
                            >
                                <label className='form-switch'>
                                    <input
                                        type='checkbox'
                                        className='form-checkbox__checkbox visually-hidden'
                                        onChange={(e) => this.handleUpdateAddress(e, formConstants.billingAddress)}
                                        name='billingAddress'
                                        id='billingAddress'
                                        checked={billingAddressValue} /><i></i>{billingAddress.label}</label>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className='bottom'>
                    <a className='edit-address' onClick={this.handleEditAddress}>
                        <span className='ico'>
                            <svg aria-hidden='true' focusable='false' data-prefix='fal' data-icon='pencil-alt' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' className='icon'>
                                <path fill='white' d='M493.255 56.236l-37.49-37.49c-24.993-24.993-65.515-24.994-90.51 0L12.838 371.162.151 485.346c-1.698 15.286 11.22 28.203 26.504 26.504l114.184-12.687 352.417-352.417c24.992-24.994 24.992-65.517-.001-90.51zM164.686 347.313c6.249 6.249 16.379 6.248 22.627 0L368 166.627l30.059 30.059L174 420.745V386h-48v-48H91.255l224.059-224.059L345.373 144 164.686 324.687c-6.249 6.248-6.249 16.378 0 22.626zm-38.539 121.285l-58.995 6.555-30.305-30.305 6.555-58.995L63.255 366H98v48h48v34.745l-19.853 19.853zm344.48-344.48l-49.941 49.941-82.745-82.745 49.941-49.941c12.505-12.505 32.748-12.507 45.255 0l37.49 37.49c12.506 12.506 12.507 32.747 0 45.255z' ></path>
                            </svg>
                        </span>
                        <span className='text'>{formMessageConstants.editAddress}</span>
                    </a>
                    <a className='remove-address' onClick={this.handleRemoveAddress}>
                        <span className='ico'>
                            <svg aria-hidden='true' focusable='false' data-prefix='fal' data-icon='trash-alt' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 448 512' className='icon'>
                                <path fill='white' d='M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z'></path></svg>
                        </span>
                        <span className='text'>{formMessageConstants.removeAddress}</span>
                    </a>
                </div>
            </div>
        </Fragment>
        );
    }
}

FormAddressDisplayField.propTypes = {
    formData: PropTypes.object.isRequired,
    address: PropTypes.object.isRequired,
    onEditAddressClick: PropTypes.func.isRequired,
    onRemoveAddressClick: PropTypes.func.isRequired,
    onUpdateAddressClick: PropTypes.func.isRequired,
    isLast: PropTypes.bool.isRequired,
};

export default FormAddressDisplayField;
